export default {
	state: {
		cadastro_incompleto: {}
	},
	getters: {
		"cadastro_incompleto": state => state.cadastro_incompleto
	},
	mutations: {
		setCadastroIncompleto(state, payload) {
			state.cadastro_incompleto = payload
		}
	},
	actions: {
		atualizarEstadoCadastroIncompleto({ commit }, payload) {
			commit('setCadastroIncompleto', payload)
		}
	}
};